"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineDevicesSubscriptionServiceServer = exports.OnlineDevicesSubscriptionServiceDispatcher = exports.OnlineDevicesSubscriptionServiceClient = void 0;
var Device_1 = require("./Device");
var octopus_common_1 = require("@playq/octopus-common");
var DeviceStatus_1 = require("./DeviceStatus");
var DevicesSubscriptions_1 = require("./DevicesSubscriptions");
var SegmentsResponse_1 = require("./SegmentsResponse");
var services_shared_1 = require("@playq/services-shared");
var DeviceID_1 = require("./DeviceID");
var RawRequestResponse_1 = require("./RawRequestResponse");
var TraitsResponse_1 = require("./TraitsResponse");
var DeviceConnection_1 = require("./DeviceConnection");
var services_common_traits_1 = require("@playq/services-common-traits");
var IdentifyStatus_1 = require("./IdentifyStatus");
var FilesResponse_1 = require("./FilesResponse");
var irt_1 = require("@playq/irt");
var InSubscribe = (function () {
    function InSubscribe(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
    }
    Object.defineProperty(InSubscribe.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    InSubscribe.prototype.serialize = function () {
        return {
            device: this.device.serialize()
        };
    };
    return InSubscribe;
}());
var OutSubscribeHelpers = (function () {
    function OutSubscribeHelpers() {
    }
    OutSubscribeHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSubscribeHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new DeviceStatus_1.DeviceStatus(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSubscribeHelpers;
}());
var InSubscriptions = (function () {
    function InSubscriptions(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InSubscriptions.prototype.serialize = function () {
        return {};
    };
    return InSubscriptions;
}());
var OutSubscriptionsHelpers = (function () {
    function OutSubscriptionsHelpers() {
    }
    OutSubscriptionsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSubscriptionsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new DevicesSubscriptions_1.DevicesSubscriptions(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSubscriptionsHelpers;
}());
var InUnsubscribe = (function () {
    function InUnsubscribe(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
    }
    Object.defineProperty(InUnsubscribe.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnsubscribe.prototype.serialize = function () {
        return {
            device: this.device.serialize()
        };
    };
    return InUnsubscribe;
}());
var OutUnsubscribeHelpers = (function () {
    function OutUnsubscribeHelpers() {
    }
    OutUnsubscribeHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUnsubscribeHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new DeviceStatus_1.DeviceStatus(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUnsubscribeHelpers;
}());
var InUpdateConnection = (function () {
    function InUpdateConnection(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.connection = new DeviceConnection_1.DeviceConnection(data.connection);
    }
    Object.defineProperty(InUpdateConnection.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateConnection.prototype, "connection", {
        get: function () {
            return this._connection;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field connection is not optional');
            }
            this._connection = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateConnection.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            connection: this.connection.serialize()
        };
    };
    return InUpdateConnection;
}());
var OutUpdateConnectionHelpers = (function () {
    function OutUpdateConnectionHelpers() {
    }
    OutUpdateConnectionHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': Device_1.DeviceHelpers.serialize(either.value)
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateConnectionHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(Device_1.DeviceHelpers.deserialize(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateConnectionHelpers;
}());
var InFormula = (function () {
    function InFormula(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.formula = new octopus_common_1.Formula(data.formula);
    }
    Object.defineProperty(InFormula.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFormula.prototype, "formula", {
        get: function () {
            return this._formula;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field formula is not optional');
            }
            this._formula = value;
        },
        enumerable: false,
        configurable: true
    });
    InFormula.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            formula: this.formula.serialize()
        };
    };
    return InFormula;
}());
var OutFormulaHelpers = (function () {
    function OutFormulaHelpers() {
    }
    OutFormulaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': services_common_traits_1.TraitHelpers.serialize(either.value)
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFormulaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(services_common_traits_1.TraitHelpers.deserialize(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFormulaHelpers;
}());
var InFiles = (function () {
    function InFiles(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.path = data.path;
    }
    Object.defineProperty(InFiles.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InFiles.prototype, "path", {
        get: function () {
            return this._path;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field path is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field path expects type string, got ' + value);
            }
            this._path = value;
        },
        enumerable: false,
        configurable: true
    });
    InFiles.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            path: this.path
        };
    };
    return InFiles;
}());
var OutFilesHelpers = (function () {
    function OutFilesHelpers() {
    }
    OutFilesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutFilesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new FilesResponse_1.FilesResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutFilesHelpers;
}());
var InTraits = (function () {
    function InTraits(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
    }
    Object.defineProperty(InTraits.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    InTraits.prototype.serialize = function () {
        return {
            device: this.device.serialize()
        };
    };
    return InTraits;
}());
var OutTraitsHelpers = (function () {
    function OutTraitsHelpers() {
    }
    OutTraitsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutTraitsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new TraitsResponse_1.TraitsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutTraitsHelpers;
}());
var InSegments = (function () {
    function InSegments(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
    }
    Object.defineProperty(InSegments.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    InSegments.prototype.serialize = function () {
        return {
            device: this.device.serialize()
        };
    };
    return InSegments;
}());
var OutSegmentsHelpers = (function () {
    function OutSegmentsHelpers() {
    }
    OutSegmentsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutSegmentsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SegmentsResponse_1.SegmentsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSegmentsHelpers;
}());
var InRawRequest = (function () {
    function InRawRequest(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.data = data.data;
    }
    Object.defineProperty(InRawRequest.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRawRequest.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field data is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field data expects type string, got ' + value);
            }
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    InRawRequest.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            data: this.data
        };
    };
    return InRawRequest;
}());
var OutRawRequestHelpers = (function () {
    function OutRawRequestHelpers() {
    }
    OutRawRequestHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRawRequestHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new RawRequestResponse_1.RawRequestResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRawRequestHelpers;
}());
var InIdentify = (function () {
    function InIdentify(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.data = data.data;
    }
    Object.defineProperty(InIdentify.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InIdentify.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field data is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field data expects type string, got ' + value);
            }
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    InIdentify.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            data: this.data
        };
    };
    return InIdentify;
}());
var OutIdentifyHelpers = (function () {
    function OutIdentifyHelpers() {
    }
    OutIdentifyHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': IdentifyStatus_1.IdentifyStatus[either.value]
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutIdentifyHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(IdentifyStatus_1.IdentifyStatus[content]);
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutIdentifyHelpers;
}());
var InDownloadFile = (function () {
    function InDownloadFile(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.device = new DeviceID_1.DeviceID(data.device);
        this.path = data.path;
        this.preview = data.preview;
    }
    Object.defineProperty(InDownloadFile.prototype, "device", {
        get: function () {
            return this._device;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field device is not optional');
            }
            this._device = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDownloadFile.prototype, "path", {
        get: function () {
            return this._path;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field path is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field path expects type string, got ' + value);
            }
            this._path = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDownloadFile.prototype, "preview", {
        get: function () {
            return this._preview;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field preview is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field preview expects boolean type, got ' + value);
            }
            this._preview = value;
        },
        enumerable: false,
        configurable: true
    });
    InDownloadFile.prototype.serialize = function () {
        return {
            device: this.device.serialize(),
            path: this.path,
            preview: this.preview
        };
    };
    return InDownloadFile;
}());
var OutDownloadFileHelpers = (function () {
    function OutDownloadFileHelpers() {
    }
    OutDownloadFileHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDownloadFileHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(content);
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDownloadFileHelpers;
}());
var OnlineDevicesSubscriptionServiceClient = (function () {
    function OnlineDevicesSubscriptionServiceClient(transport) {
        this._transport = transport;
    }
    OnlineDevicesSubscriptionServiceClient.prototype.getPackageName = function () { return OnlineDevicesSubscriptionServiceClient.PackageName; };
    OnlineDevicesSubscriptionServiceClient.prototype.getClassName = function () { return OnlineDevicesSubscriptionServiceClient.ClassName; };
    OnlineDevicesSubscriptionServiceClient.prototype.getFullClassName = function () { return OnlineDevicesSubscriptionServiceClient.FullClassName; };
    OnlineDevicesSubscriptionServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.subscribe = function (device) {
        var _this = this;
        var __data = new InSubscribe();
        __data.device = device;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'subscribe', __data)
                .then(function (data) {
                try {
                    resolve(OutSubscribeHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.subscriptions = function () {
        var _this = this;
        var __data = new InSubscriptions();
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'subscriptions', __data)
                .then(function (data) {
                try {
                    resolve(OutSubscriptionsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.unsubscribe = function (device) {
        var _this = this;
        var __data = new InUnsubscribe();
        __data.device = device;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'unsubscribe', __data)
                .then(function (data) {
                try {
                    resolve(OutUnsubscribeHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.updateConnection = function (device, connection) {
        var _this = this;
        var __data = new InUpdateConnection();
        __data.device = device;
        __data.connection = connection;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'updateConnection', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateConnectionHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.formula = function (device, formula) {
        var _this = this;
        var __data = new InFormula();
        __data.device = device;
        __data.formula = formula;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'formula', __data)
                .then(function (data) {
                try {
                    resolve(OutFormulaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.files = function (device, path) {
        var _this = this;
        var __data = new InFiles();
        __data.device = device;
        __data.path = path;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'files', __data)
                .then(function (data) {
                try {
                    resolve(OutFilesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.traits = function (device) {
        var _this = this;
        var __data = new InTraits();
        __data.device = device;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'traits', __data)
                .then(function (data) {
                try {
                    resolve(OutTraitsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.segments = function (device) {
        var _this = this;
        var __data = new InSegments();
        __data.device = device;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'segments', __data)
                .then(function (data) {
                try {
                    resolve(OutSegmentsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.rawRequest = function (device, data) {
        var _this = this;
        var __data = new InRawRequest();
        __data.device = device;
        __data.data = data;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'rawRequest', __data)
                .then(function (data) {
                try {
                    resolve(OutRawRequestHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.identify = function (device, data) {
        var _this = this;
        var __data = new InIdentify();
        __data.device = device;
        __data.data = data;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'identify', __data)
                .then(function (data) {
                try {
                    resolve(OutIdentifyHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.prototype.downloadFile = function (device, path, preview) {
        var _this = this;
        var __data = new InDownloadFile();
        __data.device = device;
        __data.path = path;
        __data.preview = preview;
        return new Promise(function (resolve, reject) {
            _this._transport.send(OnlineDevicesSubscriptionServiceClient.ClassName, 'downloadFile', __data)
                .then(function (data) {
                try {
                    resolve(OutDownloadFileHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    OnlineDevicesSubscriptionServiceClient.PackageName = 'net.playq.octopus2.devices';
    OnlineDevicesSubscriptionServiceClient.ClassName = 'OnlineDevicesSubscriptionService';
    OnlineDevicesSubscriptionServiceClient.FullClassName = 'net.playq.octopus2.devices.OnlineDevicesSubscriptionService';
    return OnlineDevicesSubscriptionServiceClient;
}());
exports.OnlineDevicesSubscriptionServiceClient = OnlineDevicesSubscriptionServiceClient;
var OnlineDevicesSubscriptionServiceDispatcher = (function () {
    function OnlineDevicesSubscriptionServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    OnlineDevicesSubscriptionServiceDispatcher.prototype.getSupportedService = function () {
        return 'OnlineDevicesSubscriptionService';
    };
    OnlineDevicesSubscriptionServiceDispatcher.prototype.getSupportedMethods = function () {
        return OnlineDevicesSubscriptionServiceDispatcher.methods;
    };
    OnlineDevicesSubscriptionServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "subscribe": {
                var obj_1 = new InSubscribe(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.subscribe(context, obj_1.device)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSubscribeHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "subscriptions": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.subscriptions(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSubscriptionsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unsubscribe": {
                var obj_2 = new InUnsubscribe(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unsubscribe(context, obj_2.device)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnsubscribeHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateConnection": {
                var obj_3 = new InUpdateConnection(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateConnection(context, obj_3.device, obj_3.connection)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateConnectionHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "formula": {
                var obj_4 = new InFormula(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.formula(context, obj_4.device, obj_4.formula)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFormulaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "files": {
                var obj_5 = new InFiles(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.files(context, obj_5.device, obj_5.path)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutFilesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "traits": {
                var obj_6 = new InTraits(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.traits(context, obj_6.device)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutTraitsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "segments": {
                var obj_7 = new InSegments(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.segments(context, obj_7.device)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSegmentsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "rawRequest": {
                var obj_8 = new InRawRequest(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.rawRequest(context, obj_8.device, obj_8.data)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRawRequestHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "identify": {
                var obj_9 = new InIdentify(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.identify(context, obj_9.device, obj_9.data)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutIdentifyHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "downloadFile": {
                var obj_10 = new InDownloadFile(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.downloadFile(context, obj_10.device, obj_10.path, obj_10.preview)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDownloadFileHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by OnlineDevicesSubscriptionServiceDispatcher."));
        }
    };
    OnlineDevicesSubscriptionServiceDispatcher.methods = [
        "subscribe",
        "subscriptions",
        "unsubscribe",
        "updateConnection",
        "formula",
        "files",
        "traits",
        "segments",
        "rawRequest",
        "identify",
        "downloadFile"
    ];
    return OnlineDevicesSubscriptionServiceDispatcher;
}());
exports.OnlineDevicesSubscriptionServiceDispatcher = OnlineDevicesSubscriptionServiceDispatcher;
var OnlineDevicesSubscriptionServiceServer = (function (_super) {
    __extends(OnlineDevicesSubscriptionServiceServer, _super);
    function OnlineDevicesSubscriptionServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    OnlineDevicesSubscriptionServiceServer.prototype.subscribe = function (context, device) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.subscriptions = function (context) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.unsubscribe = function (context, device) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.updateConnection = function (context, device, connection) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.formula = function (context, device, formula) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.files = function (context, device, path) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.traits = function (context, device) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.segments = function (context, device) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.rawRequest = function (context, device, data) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.identify = function (context, device, data) {
        throw new Error('Not implemented.');
    };
    OnlineDevicesSubscriptionServiceServer.prototype.downloadFile = function (context, device, path, preview) {
        throw new Error('Not implemented.');
    };
    return OnlineDevicesSubscriptionServiceServer;
}(OnlineDevicesSubscriptionServiceDispatcher));
exports.OnlineDevicesSubscriptionServiceServer = OnlineDevicesSubscriptionServiceServer;
//# sourceMappingURL=OnlineDevicesSubscriptionService.js.map